module.exports = __webpack_public_path__ + "static/media/all-now-logo.fc5314c7.svg";